import * as React from "react";
import {ReactElement, useMemo} from "react";
import {connect} from "react-redux";
import {Box, styled} from "@mui/material";
import {IPageProps} from "../interfaces/components/props/IPageProps";
import ImageGrid from "../components/grid/ImageGrid";
import {CAREER_SECTIONS, PERSONAL_PROJECTS} from "../Config";
import {RootState} from "../redux/store";
import Quotes from "./Quotes";
import TabsContainer from "../components/tab/TabsContainer";
import VerticalTimeline from "../components/timeline/VerticalTimeline";
import {useParams} from "react-router-dom";
import {Helmet} from "react-helmet-async";
import {routes} from "../routing/Routes";

const Root = styled(Box)(({theme}) => ({
    minHeight: '100%',
    height: 'auto',
    [theme.breakpoints.only('xs')]: {
        padding: `${theme.spacing(8)} ${theme.spacing(0)} `,
    },
    [theme.breakpoints.up('sm')]: {
        padding: `${theme.spacing(0)} ${theme.spacing(8)} ${theme.spacing(0)} ${theme.spacing(8)}`,
    },
}));

interface IProps extends IPageProps {
}

function Home({languageTokens}: IProps): ReactElement {

    const personalProjects = useMemo(() => PERSONAL_PROJECTS(languageTokens), [languageTokens]);
    const careerSections = useMemo(() => CAREER_SECTIONS(languageTokens), [languageTokens]);
    const { lang } = useParams(); // optional if you use language param

    return (
        <Root id={'Career'}>
            <Helmet>
                <title>Career Projects</title>
                <meta name="description" content="A chronological overview of my relevant work projects"/>
                <link rel="alternate" href={`https://timfehrmann.com/en/${routes.career}`} hrefLang="en"/>
                <link rel="alternate" href={`https://timfehrmann.com/de/${routes.career}`} hrefLang="de"/>
                <link rel="canonical" href={`https://timfehrmann.com/${lang}/${routes.career}`}/>
                <link rel="alternate" href="https://timfehrmann.com/" hrefLang="x-default"/>
            </Helmet>

            <Quotes/>
            <TabsContainer
                basePath={`/${lang}`}
                tabs={[
                    {
                        tabName: '',
                        headerText: languageTokens.personal,
                        content: <ImageGrid projectPages={personalProjects}/>,
                    },
                    {
                        tabName: 'career',
                        headerText: languageTokens.career,
                        content: <VerticalTimeline careerSections={careerSections} />,
                    },
                ]}
            />
        </Root>
    );
}

const mapStateToProps = (state: RootState) => ({
    languageTokens: state.language.languageTokens,
});

const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(Home);
